import { render, staticRenderFns } from "./ConfirmSelectionTermSlidebar.vue?vue&type=template&id=5f081be0"
import script from "./ConfirmSelectionTermSlidebar.vue?vue&type=script&lang=js"
export * from "./ConfirmSelectionTermSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports